(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/gift.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/gift.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const Header = svs.tickets_giftshop.gift.components.Header;
const Products = svs.tickets_giftshop.products.Products;
const MiniCart = svs.tickets_giftshop.gift.components.MiniCart;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const GiftForm = svs.tickets_giftshop.gift.giftform.GiftForm;
const _svs$components$tur$b = svs.components.tur.backgrounds,
  TrissBackground = _svs$components$tur$b.TrissBackground,
  SkrapspelBackground = _svs$components$tur$b.SkrapspelBackground;

const _svs$tickets_giftshop = svs.tickets_giftshop.constants.urlMappings,
  TRISS_HOME = _svs$tickets_giftshop.TRISS_HOME,
  SKRAPSPEL_HOME = _svs$tickets_giftshop.SKRAPSPEL_HOME;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.branding,
  TRISS = _svs$tickets_giftshop2.TRISS,
  SKRAPSPEL = _svs$tickets_giftshop2.SKRAPSPEL,
  DEFAULT = _svs$tickets_giftshop2.DEFAULT;

const functions = svs.tickets_giftshop.functions;
const urlMapping = svs.core.urlMapping;
const appendProductAction = svs.tickets_giftshop.gift.giftform.cart.actions.appendProductAction;
const inputChangeAction = svs.tickets_giftshop.gift.giftform.actions.inputChangeAction;
const _svs$tickets_giftshop3 = svs.tickets_giftshop.constants,
  dateSelectorKey = _svs$tickets_giftshop3.dateSelectorKey,
  _svs$tickets_giftshop4 = _svs$tickets_giftshop3.names,
  DATE_AND_TIME = _svs$tickets_giftshop4.DATE_AND_TIME,
  DATE_SELECTOR = _svs$tickets_giftshop4.DATE_SELECTOR;
const Gift = _ref => {
  let jupiterProducts = _ref.jupiterProducts,
    products = _ref.products,
    branding = _ref.branding,
    history = _ref.history,
    cartSum = _ref.cartSum,
    onProductAppend = _ref.onProductAppend,
    onInputChange = _ref.onInputChange;
  const balance = svs.tickets_giftshop.hooks.useBalance();
  const WidgetArea = svs.tickets_giftshop.gift.WidgetArea;
  const handleCancelClick = e => {
    e && e.preventDefault();
    let url;
    switch (branding) {
      case TRISS:
        url = TRISS_HOME;
        break;
      case SKRAPSPEL:
      case DEFAULT:
      default:
        url = SKRAPSPEL_HOME;
        break;
    }
    functions.locationAssign(urlMapping.get(url));
  };

  React.useEffect(() => {
    const paramHandler = svs.utils.paramHandler;
    const lottQuery = paramHandler.get({
      key: 'lott'
    });
    if (lottQuery.value) {
      const parsed = functions.parseTicketQuery(lottQuery.value, jupiterProducts);
      parsed.forEach(_ref2 => {
        let type = _ref2.type,
          count = _ref2.count,
          variation = _ref2.variation;
        const product = jupiterProducts.find(product => {
          const _type$split = type.split(':'),
            _type$split2 = _slicedToArray(_type$split, 1),
            name = _type$split2[0];
          const _product$type$split = product.type.split(':'),
            _product$type$split2 = _slicedToArray(_product$type$split, 1),
            productName = _product$type$split2[0];
          return name === productName && variation === product.productVariation;
        });
        for (let i = 0; i < count; i++) {
          product && onProductAppend && onProductAppend(product.productId, product.productVariation, product.type, true, product.activeTheme);
        }
      });
      paramHandler.remove({
        key: 'lott'
      });
    }

    const dateAndTime = paramHandler.get({
      key: 'datum'
    });
    if (dateAndTime.value) {
      const _dateAndTime$value$sp = dateAndTime.value.split('T'),
        _dateAndTime$value$sp2 = _slicedToArray(_dateAndTime$value$sp, 2),
        date = _dateAndTime$value$sp2[0],
        time = _dateAndTime$value$sp2[1];
      date && time && onInputChange({
        field: DATE_AND_TIME,
        value: {
          date,
          time,
          dateSelector: dateSelectorKey.DATE_AND_TIME
        }
      });
      paramHandler.remove({
        key: 'datum'
      });
    }
    const dateSelector = paramHandler.get({
      key: 'datumflik'
    });
    if (dateSelector.value) {
      const value = dateSelector.value.toUpperCase();
      if (dateSelectorKey[value]) {
        onInputChange({
          field: DATE_SELECTOR,
          value
        });
      }
      paramHandler.remove({
        key: 'datumflik'
      });
    }
  }, []);
  const isTriss = branding === TRISS;
  const isSkrapspel = branding === SKRAPSPEL;
  const isDefault = branding === DEFAULT;

  const previewOpEnabled = {
    isSubmit: true,
    formName: 'tg-gift-form',
    text: 'Förhandsgranska'
  };
  const cancelOp = {
    secondary: true,
    text: 'Avbryt',
    onClick: handleCancelClick
  };
  return React.createElement(React.Fragment, null, isTriss && React.createElement(TrissBackground, null), (isSkrapspel || isDefault) && React.createElement(SkrapspelBackground, null), React.createElement(WidgetArea, {
    areaName: "hero"
  }), React.createElement(Header, null), React.createElement(MiniCart, null), React.createElement(Products, {
    products: products
  }), React.createElement(GiftForm, {
    history: history
  }), React.createElement("div", {
    className: "tg-gift-payfooter"
  }, React.createElement(Payfooter, {
    balance: balance,
    buttons: [previewOpEnabled, cancelOp],
    hasReminder: false,
    isLegalInfo: true,
    sum: cartSum
  })));
};
const mapStateToProps = state => {
  const settings = state.settings,
    cart = state.cart,
    products = state.products;
  const targetCartState = cart[settings.branding] || {};
  return {
    branding: settings.branding,
    jupiterProducts: products.jupiterProducts,
    products: products.products,
    hasItemsInCart: targetCartState.count > 0,
    cartSum: targetCartState.sum
  };
};
const mapDispatch = dispatch => ({
  onProductAppend: (productId, productVariation, productType, viaQueryString, activeTheme) => dispatch(appendProductAction(productId, productVariation, productType, viaQueryString, activeTheme)),
  onInputChange: _ref3 => {
    let field = _ref3.field,
      value = _ref3.value;
    return dispatch(inputChangeAction({
      field,
      value
    }));
  }
});
svs.tickets_giftshop.gift.Gift = ReactRedux.connect(mapStateToProps, mapDispatch)(Gift);

 })(window);